import React from 'react';
import { Link } from 'react-router-dom';

import checkmarkIcon from '../../../images/icons/icon-checkmark-blue.svg';

const AccountRow = ({ account, flags }) => {
  const id = account.pub_id || account.merch_id;
  const accountType = account.merch_id ? 'merchant' : 'publisher';
  const typeText =
    accountType === 'merchant'
      ? 'Merchant'
      : account.publisher_type === 1
      ? 'Publisher'
      : 'Creator';

  const categories =
    account.categories &&
    account.categories.map((category, index) => (
      <div className="category-chip" key={index}>
        {category}
      </div>
    ));

  const categoriesContainer = flags.accountCategorization ? (
    <span className="categories">{categories}</span>
  ) : null;

  const acceptedCheck = account.terms_accepted ? <img src={checkmarkIcon} alt="" /> : null;

  const logo = account.logo_url ? (
    <div className="img-container">
      <img className="logo-img" src={account.logo_url} alt="info" />
    </div>
  ) : null;

  return (
    <div className="row">
      <Link className="row-container" to={`/v2/admin/accounts/edit/${accountType}/${id}`}>
        <div className="logo">{logo}</div>
        <span className="company">{account.full_name}</span>
        <span className="account-type">{typeText}</span>
        {categoriesContainer}
        <span className="terms-accepted">{acceptedCheck}</span>
      </Link>
    </div>
  );
};

export default AccountRow;
